/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_Cta_DownloadInputs */

const en_fc_home_hero_cta_download = /** @type {(inputs: Fc_Home_Hero_Cta_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the download guide`)
};

/**
* | output |
* | --- |
* | "Get the download guide" |
*
* @param {Fc_Home_Hero_Cta_DownloadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_cta_download = /** @type {((inputs?: Fc_Home_Hero_Cta_DownloadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_Cta_DownloadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_cta_download(inputs)
});
export { fc_home_hero_cta_download as "fc.home.hero.cta_download" }